var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FormControlLabel, Radio, RadioGroup, styled, useMediaQuery } from "@mui/material";
var CustomRadioGroup = styled(RadioGroup, {
    shouldForwardProp: function (prop) { return prop !== "mob"; },
})(function (_a) {
    var theme = _a.theme, mob = _a.mob;
    var isMobile = useMediaQuery("(max-width: 760px)");
    return __assign({ flexDirection: "row", "& .MuiFormControlLabel-root": {
            marginRight: theme.spacing(2),
        }, "& .MuiFormControlLabel-label": {
            fontSize: "14px",
            fontWeight: 400,
        } }, (mob &&
        isMobile && {
        flexDirection: "column",
        gap: theme.spacing(2),
    }));
});
export var RequerimentoCustomRadioGroup = function (_a) {
    var options = _a.options, mob = _a.mob, props = __rest(_a, ["options", "mob"]);
    return (_jsx(CustomRadioGroup, __assign({ mob: mob }, props, { children: options.map(function (option) { return (_jsx(FormControlLabel, { value: option.value, control: _jsx(Radio, {}), label: option.label, disabled: option.disabled }, option.value)); }) })));
};
